import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { Typography } from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import neshan from '../../../../../api/neshan';
import { useToast } from '../../../../../hooks/useToast';
import { useQuery } from 'react-query';
import { Skeleton } from '@material-ui/lab';
import moment from 'moment-jalaali';
import { useHistory } from 'react-router-dom';
import { __ } from 'utils/i18n';

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: 'auto',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    '& .isVerified': {
      backgroundColor: 'orange',
      color: 'gray',
      padding: '0 8px',
      borderRadius: '3px',
      '& .text': {
        fontSize: '11px',
        whiteSpace: 'nowrap',
      },
    },
  },
  small: {
    width: '35px',
    height: '35px',
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '0px !important',
    width: '100%',
  },
}));

const ReportsListItem = ({ report, id, driver }) => {
  const classes = useStyles();
  const toast = useToast();
  const history = useHistory();
  const loadLocation = async (coordinates) => {
    if (!coordinates) return;
    try {
      const { data } = await neshan.get(
        `/v2/reverse?lat=${coordinates?.[0]}&lng=${coordinates?.[1]}`
      );
      return data.formatted_address;
    } catch (error) {
      toast.error(error);
    }
  };

  const handleRedirectToDriver = () => {
    history.push(`/protected/admin/users/driver/${driver?.user?._id}`);
  };

  const { data, isLoading } = useQuery(
    ['callListLocation', id, report?.driver?.location?.coordinates],
    () => loadLocation(report?.driver?.location?.coordinates)
  );
  
  return (
    <>
      <ListItem className={classes.root}>
        <div
          onClick={handleRedirectToDriver}
          className={classes.item + ' cursor-pointer'}
        >
          <ListItemAvatar>
            <Avatar />
          </ListItemAvatar>
          <ListItemText
            primary={report.user.lastName}
            secondary={`${report.driver?.fleetOptions?.[0]?.fleet?.title} ${report.driver?.fleetOptions?.[0]?.title}`}
          />
          <div className="d-flex flex-column">
            <div className="isVerified orange textWhtie">
              {report.user && (
                <Typography className="text text-center">
                  {__(report.resultOfCall)}
                </Typography>
              )}
            </div>
            <div style={{ fontSize: 12, color: '#ccc' }}>
              {moment(report.createdAt).format('jYYYY/jMM/jDD HH:mm')}
            </div>
          </div>
        </div>
        <a href={`tel:${report.user.mobilePhone}`}>
          <ListItemAvatar>
            <Avatar className={'whatsapp textWhite me-2 ' + classes.small}>
              <CallIcon fontSize="small" />
            </Avatar>
          </ListItemAvatar>
        </a>
      </ListItem>
      <div className="mb-2 mx-4 text-end">
        {isLoading && !data ? (
          <Skeleton className="w-100" variant="text" height={20} />
        ) : !isLoading && !data ? (
          <div>موقعیت راننده وجود ندارد</div>
        ) : (
          <Typography
            style={{ fontSize: 12, color: 'gray', textAlign: 'right' }}
          >
            {data}
          </Typography>
        )}
      </div>
    </>
  );
};

export default ReportsListItem;
